"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PluginShare = void 0;

var _webviewProtocol = require("@daangn/webview-protocol"),
    _createMessage = require("../core/createMessage"),
    _Base = require("./Base");

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var PluginShare = /*#__PURE__*/function (_Base$PluginBase) {
  _inherits(PluginShare, _Base$PluginBase);

  var _super = _createSuper(PluginShare);

  function PluginShare() {
    var _this;

    _classCallCheck(this, PluginShare);

    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(a)), _defineProperty(_assertThisInitialized(_this), "namespace", "share");
    return _this;
  }

  _createClass(PluginShare, [{
    key: "open",
    value: function open(_ref) {
      var a = _ref.url,
          b = _ref.text;
      this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqShareOpen,
        payload: {
          share: {
            url: a,
            text: b
          }
        }
      }));
    }
  }]);

  return PluginShare;
}(_Base.PluginBase);

exports.PluginShare = PluginShare;